import template from './analytics-traffic.html';
import controller from './analytics-traffic.controller';
import './analytics-traffic.styl';

let analyticsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default analyticsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-traffic/analytics-traffic.component.js
 **/